export default __webpack_public_path__ + "static/media/pic1.9f5e0fa0.jpg";